// File: src/components/ProtectedRoute.js
// This component protects routes that require authentication.
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const token = localStorage.getItem('authToken');

  // If a token exists, the user is authenticated, so render the requested page.
  // The <Outlet /> component is a placeholder for the nested route component (e.g., AdminDashboard).
  if (token) {
    return <Outlet />;
  }

  // If no token exists, redirect the user to the login page.
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
